import React, { useEffect, useState } from 'react'
import styles from '../styles/newFeature.module.css';
import Image from 'next/image';
import ReactTyped from 'react-typed';
import { BlackCustomButton, ComparisionSection, DifferenceSection, HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton, WhiteCustomButton } from '@/components/qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import content from '../language/ENGLISH.json'
import OutletFeatures from '@/components/common/OutletFeatures';
import TestimonialSection from '@/components/common/TestimonialSection';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import { FootwearwhyQB, footwearFAQ, footwearFeatures, footwearOtherFeatures } from '@/constants/outlets';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { ThreeSimpleSteps } from '@/components/mobileQbStrap';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import { OurPartners } from './homePage/OurPartners';
import { MobileOurPartners } from './homePage/MobileOurPartners';
import FAQ_mobile from './Industry/FAQ_mobile';
import MobileTestimonialSection from './common/MobileTestimonialSection';
import MobilePDBanner from './common/MobilePDBanner';

const EwayBilling = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            title: "Effortless eWay Billing for Retail Businesses",
            desc: "If your retail business involves stock transfers exceeding ₹50,000, QueueBuster’s ultra-fast eWay Bill generation feature is designed to help. The software records, manages, and tracks all your past and future bills, ensuring compliance is always just a click away.",
            point: [
                <><b>Eliminate Manual Paperwork:</b> Say goodbye to the administrative burden of paperwork. QueueBuster automates the process, reducing errors and saving valuable time.</>,
                <><b>Real-Time Tracking of Goods:</b> Monitor the movement of your goods in real-time, ensuring timely deliveries and improved operational efficiency.</>,
                <><b>Cost and Time Savings:</b> Enhance accuracy and compliance while reducing overhead costs and time spent on manual eWay Bill processes.</>
            ],
            image: "/assets/features/eway-billing/retail-business.webp",
            stack3Clr: "#fff6e1",
            stack2Clr: "#FFE9B6",
            stack1Clr: "#ffe097",
            imgHeight: "42rem",
            mobImgHeight: "24rem",
            borderColor: "#ffba00",
            ptContainerHeight: "6rem",
            mobPtContainerHeight: "7rem"
        },
        {
            id: 2,
            title: "Powerful eWay Billing for GST Compliance",
            desc: "QueueBuster's eWay Bill solution simplifies eWay Bill management, offering secure branch-level access control and centralized data storage for businesses. The software is packed with features that streamline logistics and ensure compliance with the latest GST regulations.",
            point: [
                <><b>Branch-Level Access Control:</b> Securely manage access to eWay Bill generation at different locations, maintaining control and privacy at every level of your organization.</>,
                <> <b>Bulk Updates of Transporter Details:</b> Easily update key information, including vehicle numbers, consignee details, and transporter IDs, all from one platform, simplifying the logistics process.</>,
                <><b>Multi-Location Bill Generation:</b> Generate eWay Bills across multiple locations with centralized data storage, ensuring smooth warehouse operations and accurate tracking.</>
            ],
            image: "/assets/features/eway-billing/business.webp",
            stack3Clr: "#E2FBFF",
            stack2Clr: "#C2F7FF",
            stack1Clr: "#A1F3FF",
            imgHeight: "52rem",
            mobImgHeight: "30rem",
            borderColor: "#8AE4F6",
            ptContainerHeight: "6rem",
            mobPtContainerHeight: "7rem"
        }
    ]

    const whyQBeWayBill = [
        {
            id: 1,
            title: "Quick and Seamless eWay Bill Generation",
            desc: "With QueueBuster, you can generate eWay Bills directly from your invoices in seconds. The system auto-populates relevant details, minimizing manual input and reducing the chances of errors."
        },
        {
            id: 2,
            title: "Automatic Validation for Accuracy",
            desc: "The software automatically validates the GSTIN, HSN codes, and other necessary fields to ensure that the eWay Bills are accurate and comply with GST norms. This minimizes the risk of errors that could lead to non-compliance or penalties during transportation."
        },
        {
            id: 3,
            title: "Bulk eWay Bill Generation",
            desc: "For businesses handling large shipments or multiple consignments, QueueBuster supports bulk eWay Bill generation. This feature allows users to generate numerous eWay Bills simultaneously, saving time and reducing operational bottlenecks."
        },
        {
            id: 4,
            title: "Real-Time Vehicle Tracking and Updates",
            desc: "QueueBuster offers real-time tracking of vehicles carrying your goods, providing live updates on the status and location of shipments. This helps businesses manage delivery schedules more effectively and ensures on-time deliveries."
        },
        {
            id: 5,
            title: "Centralized Data Management",
            desc: "All eWay Bills generated from different branches or locations are stored in a centralized database, allowing for easy access and management of records. Businesses can monitor and manage their bills from multiple locations seamlessly."
        },
        {
            id: 6,
            title: "Transporter Details and Route Optimization",
            desc: "Easily update transporter details, including vehicle number, transporter ID, and consignee information, to streamline logistics. QueueBuster also helps in route management, reducing transit delays and optimizing the delivery process."
        },
        {
            id:7,
            title:"Multi-User Access with Role-Based Permissions",
            desc:"QueueBuster allows for multi-user access, ensuring that different departments (sales, warehouse, logistics) can work together on eWay Bill creation and management. Role-based permissions ensure secure access control, maintaining data privacy."
        },
        {
            id:8,
            title:"GST Compliance and Real-Time Alerts",
            desc:"Stay compliant with GST regulations by leveraging QueueBuster’s real-time alerts for upcoming deadlines, expired eWay Bills, and incorrect or missing data. This ensures that your business avoids penalties and maintains operational efficiency."
        },
        {
            id:9,
            title:"Integration with Accounting and ERP Systems",
            desc:"QueueBuster integrates seamlessly with popular accounting and ERP software, including Tally and Zoho Books, allowing for automatic data flow between systems. This integration reduces duplication of work and ensures data consistency."
        },
        {
            id:10,
            title:"24/7 Support and Assistance",
            desc:"QueueBuster offers round-the-clock support to help businesses resolve any issues related to eWay Bill generation, ensuring uninterrupted operations. Whether it’s a technical query or a compliance concern, the dedicated support team is always available."
        }

    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is e-Way bill software?
                </span>
            ),
            des: "e-Way bill software is a sophisticated digital platform designed to streamline and automate the process of generating electronic way bills (e-Way bills) for the movement of goods. It serves as a critical component of modern logistics and supply chain management, ensuring compliance with tax regulations, particularly under the Goods and Services Tax (GST) framework in India. This software enables businesses to input, process, and manage essential information such as invoice details, product descriptions, transporter information, vehicle numbers, and tax specifics, all of which are necessary for the legal transport of goods across state borders.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to generate an e-Way bill?
                </span>
            ),
            des: "Generating an e-Way bill involves a systematic process facilitated by e-Way bill software or online portals such as the one provided by the Government of India. Users begin by logging into the e-Way bill platform and entering relevant data, including but not limited to invoice numbers, product specifics (like quantity and value), supplier details, recipient information, transporter ID, vehicle number, and the GST Identification Number (GSTIN) of all parties involved. Advanced e-Way bill software like QueueBuster POS simplifies this process by integrating these functionalities into a user-friendly interface, reducing manual errors and ensuring compliance with regulatory requirements. Once all necessary information is entered accurately, the system validates the data and generates a unique e-Way bill, which serves as a digital document authorizing the movement of goods.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    When is an e-Way bill required or not required?
                </span>
            ),
            des: "The requirement for an e-Way bill is determined by the value and nature of the goods being transported. Generally, an e-Way bill is mandatory for the movement of goods valued at or above specific thresholds, which vary from state to state and are set by tax authorities. These thresholds typically range from Rs. 50,000 to Rs. 1,00,000, depending on the state. Additionally, certain categories of goods are exempted from e-Way bill requirements, such as exempted goods under GST, non-taxable goods, and goods being transported by non-motorized conveyances. Understanding these criteria is crucial for businesses to ensure compliance and avoid penalties related to e-Way bill violations.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to cancel an e-Way bill?
                </span>
            ),
            des: "Cancelling an e-Way bill can be done within 24 hours of its generation. The process involves accessing the e-Way bill portal, logging into the user account, and navigating to the 'Cancel EWB' option. Users then select the relevant e-Way bill that needs to be canceled, provide a valid reason for cancellation, and submit the request. After successful cancellation, the system updates the status of the e-Way bill accordingly. It's important to note that once the 24-hour window expires, e-Way bills cannot be canceled, and any necessary modifications must be made through proper channels per tax regulations.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to make an e-Way bill?
                </span>
            ),
            des: "Creating an e-Way bill requires meticulous attention to detail and accurate data entry. The process begins with gathering essential information related to the consignment, including invoice details (such as invoice number, date, and value), supplier information (name, address, and GSTIN), recipient details (name, address, and GSTIN), transporter ID, vehicle number, product descriptions (quantity, HSN code, and value), and relevant tax specifics. This information is then entered into the e-Way bill software or portal, either manually or through integration with business accounting systems like QueueBuster POS, which automates data entry and validation processes. The software validates the entered data, performs necessary calculations (such as tax amounts), and generates a unique e-Way bill, which is then made available for download and printing.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is an e-Way bill required for a service invoice?
                </span>
            ),
            des: "e-Way bills are primarily associated with the movement of goods rather than services. However, there are scenarios where e-Way bills may be required for services involving goods. For instance, if a service includes the supply of goods as part of a composite supply or works contract, an e-Way bill may be necessary. Businesses need to consult with tax experts or refer to specific GST regulations to determine when e-Way bills are required for service invoices, as this can vary based on the nature of the transaction and applicable tax laws.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to change the mobile number in the e-Way bill portal?
                </span>
            ),
            des: "Updating contact information such as mobile numbers in the e-Way bill portal involves accessing the user profile section and selecting the option to edit or update contact details. Users are typically required to verify the new mobile number through a verification code sent to the updated mobile number or through other authentication methods provided by the portal. Once the mobile number is successfully updated and verified, users can receive notifications and alerts related to e-Way bills on the new mobile number, ensuring effective communication and compliance management.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to know the e-Way bill password?
                </span>
            ),
            des: "In case of a forgotten e-Way bill password, users can initiate a password recovery process through the e-Way bill portal. This typically involves accessing the 'Forgot Password' or 'Reset Password' option on the login page, where users are prompted to enter their registered email address or mobile number associated with the e-Way bill account. Upon submitting the required information, the portal sends a password reset link or verification code to the registered email address or mobile number. Users can then follow the instructions provided to reset their password and regain access to their e-Way bill account, ensuring secure management of e-Way bill-related activities.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to cancel an e-Way bill after 24 hours?
                </span>
            ),
            des: "Canceling an e-Way bill after the 24-hour window requires adherence to specific procedures outlined by tax authorities. Typically, businesses need to contact the relevant tax department or support channels designated for e-Way bill queries and assistance. They may be required to provide valid reasons for the delayed cancellation and follow any additional guidelines or documentation requirements specified by the authorities. Businesses need to maintain records of all communications and actions taken regarding e-Way bill cancellations beyond the 24-hour timeframe to ensure transparency and compliance with regulatory protocols.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can we issue one e-Way bill for multiple invoices?
                </span>
            ),
            des: "Yes, under certain conditions, businesses can consolidate multiple invoices into a single e-Way bill. This consolidation is permissible when the invoices pertain to the same consignor (supplier), consignee (recipient), transporter, and mode of transport (vehicle). Additionally, all goods covered under the multiple invoices must be intended for delivery at the same location. Consolidating multiple invoices into one e-Way bill streamlines documentation and facilitates efficient logistics management, especially for bulk shipments or transactions involving multiple products.",
            id: 10,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What happens if a wrong e-Way bill is generated?
                </span>
            ),
            des: "Generating an incorrect e-Way bill can lead to compliance issues and potential penalties. Businesses must identify and rectify such errors promptly. If a wrong e-Way bill is generated, the recommended course of action is to cancel the erroneous e-Way bill as soon as possible within the permissible timeframe (typically within 24 hours). Following cancellation, businesses should generate a new and correct e-Way bill with accurate information to ensure legal compliance and avoid disruptions in goods transportation.",
            id: 11,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How is the e-Way bill calculated?
                </span>
            ),
            des: "The calculation of an e-Way bill involves determining the value of goods being transported along with applicable taxes. The value of goods is derived from the invoice amount, including any additional charges such as packing, freight, and insurance, if not already included in the invoice. Taxes, including GST (Goods and Services Tax), are calculated based on the GST rate applicable to the goods being transported. The total value of goods and taxes forms the basis for calculating the e-Way bill, ensuring accuracy and compliance with tax regulations.",
            id: 12,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How many types of e-Way bills are there?
                </span>
            ),
            des: "There are two main types of e-Way bills: Regular e-Way bills and Consolidated e-Way bills. Regular e-Way bills are generated for individual consignments of goods, where each bill corresponds to a specific invoice and transport vehicle. Consolidated e-Way bills, on the other hand, are used to consolidate multiple individual e-Way bills into a single document for ease of transportation and compliance. Within these categories, there are further distinctions based on the mode of transport (road, rail, air, or ship) and the distance of transportation (intrastate or interstate), ensuring flexibility and efficiency in e-Way bill management.",
            id: 13,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What documents are required for an e-Way bill?
                </span>
            ),
            des: <>
                To generate an e-Way bill, several documents and information are typically required, including:
                <ul>
                    <li> Invoice or bill of supply related to the consignment</li>
                    <li>Transporter ID or vehicle number (for road transport)</li>
                    <li>Supplier's GSTIN and invoice details</li>
                    <li>Recipient's GSTIN and delivery address</li>
                    <li>HSN (Harmonized System of Nomenclature) code of goods</li>
                    <li>Quantity and value of goods being transported</li>
                    <li>Relevant tax details and rates</li>
                </ul>
                Providing accurate and complete information ensures the validity and legality of the e-Way bill for goods transportation.
            </>,
            id: 14,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the e-Way bill format?
                </span>
            ),
            des: "The e-Way bill format consists of a unique document generated electronically, containing essential details related to the consignment of goods. The format includes information such as the e-Way bill number, date of generation, validity period, consignor and consignee details (including GSTIN), transport details (vehicle number or transporter ID), product descriptions (including HSN code, quantity, and value), tax information, and digital signatures where applicable. The format is standardized to facilitate easy verification and compliance checks during goods transportation.",
            id: 15,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the e-Way bill limit?
                </span>
            ),
            des: "The e-Way bill limit refers to the threshold value above which an e-Way bill is mandatory for goods transportation. This threshold varies by state and is determined by tax authorities. Generally, the e-Way bill limit ranges from Rs. 50,000 to Rs. 1,00,000 for intrastate and interstate transport of goods. Understanding and adhering to the e-Way bill limit is essential for businesses to ensure compliance with tax regulations and avoid penalties for non-compliance.",
            id: 16,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the difference between an e-Way bill and an e-invoice?
                </span>
            ),
            des: "An e-Way bill is a document required for the movement of goods, containing details such as the consignment, supplier, recipient, transport, and tax information. It serves as proof of compliance with GST regulations during goods transportation. On the other hand, an e-invoice is an electronic invoice generated digitally by businesses for the sale of goods or services. It includes details such as invoice number, date, supplier and recipient details, item descriptions, quantities, prices, and applicable taxes. While both e-Way bills and e-invoices are digital documents, they serve different purposes within the context of taxation and business transactions.",
            id: 17,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Who needs an e-Way bill?
                </span>
            ),
            des: "Businesses involved in the transportation of goods valued above the specified threshold (e-Way bill limit) are required to generate and carry e-Way bills for compliance with GST regulations. This includes manufacturers, traders, distributors, logistics providers, and other entities engaged in the supply chain. Understanding the criteria for e-Way bill requirements and ensuring the timely generation of e-Way bills is crucial for businesses to facilitate smooth and lawful goods transportation operations.",
            id: 18,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Who can accept or reject the e-Way bill and what is the time limit?
                </span>
            ),
            des: "The acceptance or rejection of an e-Way bill is typically handled by the transporter or the person in charge of transporting the goods. Upon inspection and verification of the e-Way bill details, the transporter can accept or reject the e-Way bill within a specified time limit. The time limit for acceptance or rejection varies depending on the mode of transport and distance covered. Generally, the transporter is required to either accept or reject the e-Way bill before the goods reach their destination, ensuring proper documentation and compliance throughout the transportation process.",
            id: 19,
            activeIndex: 0,
        },
    ]

    const eWayBill = {
        stack1Clr: "#E3B8FD",
        stack2Clr: "#EFD5FF",
        stack3Clr: "#FCF7FF",
        content: <div className={styles.whyQBeWayBill} >
            <h4>QueueBuster POS eWay Bill Feature: Streamlining Goods Movement for Businesses</h4><br />
            <p>The QueueBuster POS eWay Bill Feature is designed to make compliance with India’s eWay Bill requirements simple and efficient for businesses involved in the movement of goods. Whether you're a retailer, manufacturer, wholesaler, or logistics provider, QueueBuster’s eWay Bill tool enables quick generation, management, and tracking of eWay Bills in compliance with GST regulations.</p>
            <ul>
                {
                    whyQBeWayBill.map((ele) => {
                        return (
                            <li style={{ borderColor: "#E3B8FD"}}>
                                <h5>{ele.title}</h5>
                                <p>{ele.desc}</p>
                            </li>
                        )
                    })
                }
            </ul>
            <div className={styles.harwdare_device}><Image src="/assets/hardware/APOS.webp" alt="hardware device" fill /></div>
        </div>
    }

    const [heroReadMore, setHeroReadMore] = useState(false);

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/features/eway-billing/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>Rapidly Generate <br/> e-Way Bills For</span><br />
                                <span><ReactTyped strings={["Retail", "Grocery", "Warehouses", "Transporters", "Manufacturing"]} typeSpeed={200} loop /></span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>The QueueBuster POS eWay Bill Feature is designed to make compliance with India’s eWay Bill requirements simple and efficient for businesses involved in the movement of goods. Whether you're a retailer, manufacturer, wholesaler, or logistics provider, QueueBuster’s eWay Bill tool enables quick generation, management, and tracking of eWay Bills in compliance with GST regulations.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn}>Try It Free</button>
                                <button className={styles.border_btn}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 4.3rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/features/eway-billing/hero-img.webp"
                            heading={<>Rapidly Generate<br/> e-Way Bills For</>}
                            typedHeading={["Retail", "Grocery", "Warehouses", "Transporters", "Manufacturing"]}
                            description={"The QueueBuster POS eWay Bill Feature is designed to make compliance with India’s eWay Bill requirements simple and efficient for businesses involved in the movement of goods. Whether you're a retailer, manufacturer, wholesaler, or logistics provider, QueueBuster’s eWay Bill tool enables quick generation, management, and tracking of eWay Bills in compliance with GST regulations."}
                            outlinedBtn={true}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.cards_section}>
                {features?.map((ele) => <StackContainers ele={ele} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={mobileView} />)}
            </div>

            <div className={styles.comparision_section}>
                <div className={styles.section_heading}><h3>Why Use QueueBuster e-Way Bill Software?</h3><div className={styles.heading_stroke}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <ComparisionSection />
            </div>

            <div style={{marginBottom: "10rem"}}><StackSkeleton ele={eWayBill} /></div>

            {
                mobileView ? <MobileOurPartners title={"Partners and Integrations"} /> : <OurPartners title={"Partners and Integrations"} />
            }

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ? 
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs of QB E-way Billing Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs of QB E-way Billing Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default EwayBilling